<template>
    <jet-dialog-modal ref="modal" :show="show_modal" maxWidth="lg" @close="show_modal = false">

        <template v-slot:title>
            <div class="text-gray-700 text-base font-medium">Email a Teammate</div>
        </template>

        <template v-slot:content>

            <div class="text-gray-600 text-sm">
                We’ll send a message with instructions for installation
            </div>

            <div class="text-gray-600 grid grid-cols-6 mt-3 gap-4">

                <div class="col-span-2 flex flex-col justify-center text-right">
                    <jet-label for="email" value="Send to" class="text-base" />
                </div>
                <div class="col-span-4 flex flex-col justify-center pr-6">
                    <jet-input id="email" type="email" class="mt-1 mr-6 block w-full" v-model="form.email"
                        placeholder="Enter teammate’s email address" />
                </div>

            </div>
        </template>

        <template v-slot:footer>
            <div class="flex w-full flex-row justify-between">
                <div class="flex">
                    <jet-secondary-button :disabled="form.processing" @click.prevent="show_modal = false">
                        Cancel
                    </jet-secondary-button>
                </div>
                <div class="flex">
                    <jet-button :disabled="form.processing || !validateEmail()" @click="emailTeammate">
                        Send message
                    </jet-button>
                </div>
            </div>
        </template>

    </jet-dialog-modal>
</template>

<script>

import JetDialogModal from '@/Jetstream/DialogModal'
import JetButton from '@/Jetstream/Button'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'

export default {

    props: ['type'],

    components: {
        JetDialogModal, JetButton, JetSecondaryButton, JetInput, JetLabel
    },

    emits: ['confirmed'],

    data() {
        return {
            show_modal: false,
            form: {
                email: '',
                error: ''
            },
        }
    },

    methods: {
        open: function () {
            this.show_modal = true
        },
        close: function () {
            this.show_modal = false
        },
        emailTeammate: function () {
            this.form.processing = true;

            axios.post(route('settings.install.email'), {
                teammate: this.form.email,
                type: this.type,
            }).then(() => {
                this.form.processing = false;
                this.close()
                this.$nextTick(() => this.$emit('confirmed'));
            }).catch(error => {
                console.error(error)
                this.form.processing = false;
                this.form.error = error.response.data.errors.password[0];
                this.$refs.email.focus()
            })
        },
        validateEmail: function () {
            //let email = this.$refs.email.val()
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(this.form.email);
        }
    }
}

</script>
